import NataDefinition from './NataDefinition'
export default NataDefinition